/* ==========================================================================
   section-gf-collection-toolbar.js — Collection page, bands 3 + 4.

   PROGRESSIVE ENHANCEMENT ONLY. Everything this file does is already possible
   without it: the chips are links, the filter menus are native <details>, and
   the sort control is a GET form with a visible submit button. Delete this
   file and the band still filters and sorts — it just costs one extra click.

   What it adds:
     1. Sort submits on change, and the "Go" button is hidden (the form gains
        --js, which is the ONLY thing that hides it — a script-free visitor
        keeps the button).
     2. Opening one filter closes the others, so two menus never overlap.
     3. Escape closes the open menu and puts focus back on its chip, which the
        native element does not do.
     4. A pointer press outside closes it — the mobile sheet has no backdrop.
   ========================================================================== */

(function () {
  'use strict';

  var SECTION = '[data-gf="collection-toolbar"]';

  function initSort(form) {
    if (form.dataset.gfSortReady === 'true') return;
    form.dataset.gfSortReady = 'true';

    var select = form.querySelector('[data-gf-sort-select]');
    if (!select) return;

    // Only now is the submit button redundant.
    form.classList.add('gf-collection-toolbar__sort--js');

    select.addEventListener('change', function () {
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        form.submit();
      }
    });
  }

  function closeOthers(root, keep) {
    var open = root.querySelectorAll('[data-gf-toolbar-filter][open]');
    for (var i = 0; i < open.length; i += 1) {
      if (open[i] !== keep) open[i].removeAttribute('open');
    }
  }

  function initFilters(root) {
    var details = root.querySelectorAll('[data-gf-toolbar-filter]');
    if (!details.length) return;

    for (var i = 0; i < details.length; i += 1) {
      (function (el) {
        if (el.dataset.gfFilterReady === 'true') return;
        el.dataset.gfFilterReady = 'true';

        el.addEventListener('toggle', function () {
          if (el.open) closeOthers(root, el);
        });
      })(details[i]);
    }
  }

  function openDetailsIn(root) {
    return root.querySelector('[data-gf-toolbar-filter][open]');
  }

  function init(root) {
    var forms = root.querySelectorAll('[data-gf-sort-form]');
    for (var i = 0; i < forms.length; i += 1) initSort(forms[i]);
    initFilters(root);
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll(SECTION);
    for (var i = 0; i < roots.length; i += 1) init(roots[i]);
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' && event.key !== 'Esc') return;

    var roots = document.querySelectorAll(SECTION);
    for (var i = 0; i < roots.length; i += 1) {
      var open = openDetailsIn(roots[i]);
      if (!open) continue;
      open.removeAttribute('open');
      var summary = open.querySelector('summary');
      if (summary) summary.focus();
    }
  });

  document.addEventListener('pointerdown', function (event) {
    var roots = document.querySelectorAll(SECTION);
    for (var i = 0; i < roots.length; i += 1) {
      var open = openDetailsIn(roots[i]);
      if (open && !open.contains(event.target)) open.removeAttribute('open');
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  // Theme editor: a re-rendered section arrives with no listeners attached.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
